export enum MedicalPto {    
    No = 0,
    NoVacation = 1,
    YesEmployerReimburses = 2,
    YesRecipientReimburses = 3,
    YesOtherReimburses = 4
}